import Filter from './filter';

export default Filter((FILTER_TYPES) => ({
  id: 'BAR',
  analyticsName: 'Bar',
  queryKey: 'f_bar',
  type: FILTER_TYPES.BOOLEAN,
  bucketify: (hotel) => {
    const facts = hotel?.hotelFacts;

    if (!facts) {
      return {
        bucketId: FILTER_TYPES.BINARY_BUCKET.FALSE,
        bucketName: 'bar',
      };
      // return FILTER_TYPES.BINARY_BUCKET.FALSE;
    }

    for (let i = 0; i < facts.length; i += 1) {
      const fact = facts[i];

      if (fact && fact.id === 'noBars') {
        return {
          bucketId: fact.filterValue ? FILTER_TYPES.BINARY_BUCKET.TRUE : FILTER_TYPES.BINARY_BUCKET.FALSE,
          bucketName: 'bar',
        };
        // return fact.filterValue ? FILTER_TYPES.BINARY_BUCKET.TRUE : FILTER_TYPES.BINARY_BUCKET.FALSE;
      }
    }

    return {
      bucketId: FILTER_TYPES.BINARY_BUCKET.FALSE,
      bucketName: 'bar',
    };
  },
  toQuery: ({ value }) => {
    return value ? 1 : undefined;
  },
  fromQuery: (rawQueryValue) => {
    return {
      [FILTER_TYPES.BINARY_BUCKET.TRUE]: !!rawQueryValue,
    };
  },
}));
